<template>
  <div class="container" :style="`background-image: url(${detailBack})`">
    <!-- <Header :theme="theme" :position="'relative'"></Header> -->
    <div :class="`content in`">
      <div class="text">
        <p class="title">用户协议</p>
        <p class="info">尊敬的用户，欢迎使用南京浩伟智能的产品及服务。在使用前请您阅读如下服务协议，使用本网站即表示您同意接受本协议，本协议产生法律效力，特别涉及免除或者限制责任的条款，请仔细阅读。如有任何问题，可及时与我们联系。</p>
        <p class="info">1. 服务条款的确认和接受</p>
        <p class="info">通过访问或使用本网站，表示用户同意接受本协议的所有条件和条款。通过访问或使用本网站，表示用户同意接受本协议的所有条件和条款。</p>
        <p class="info">浩伟智能技术人员有权在必要时修改服务条款，服务条款一旦发生变更，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以放弃获得的本网站信息服务。 如果用户继续享用本网站的信息服务，则视为接受服务条款的变更。本网站保留随时修改或中断服务而不需要通知用户的权利。 本网站行使修改或中断服务的权利，不需对用户或第三方负责。</p>
        <p class="info">3. 用户行为</p>
        <p class="info">3.1 用户账号、密码和安全</p>
        <p class="info">用户一旦注册成功，便成为浩伟智能的合法用户，将得到一个密码和帐号。用户应采取合理措施维护其密码和帐号的安全。用户对利用该密码和帐号所进行的一切活动负全部责任；由该等活动所导致的任何损失或损害由用户承担，浩伟智能技术人员不承担任何责任。 用户的密码和帐号遭到未授权的使用或发生其他任何安全问题，用户可以立即通知浩伟智能技术人员，并且用户在每次连线结束，应结束帐号使用，否则用户可能得不到安全保护。对于用户长时间未使用的帐号，浩伟智能技术人员有权予以关闭并注销其内容。</p>
        <p class="info">3.2 账号注册时的禁止行为</p>
        <p class="info">（1）请勿以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；</p>
        <p class="info">（2）冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的名称；</p>
        <p class="info">（3）请勿注册和其他网友之名相近、相仿的名字；</p>
        <p class="info">（4）请勿注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的名字；</p>
        <p class="info">（5）请勿注册易产生歧义、引起他人误解的名字；</p>
        <p class="info">3.3 用户在本网站上不得发布下列违法信息和照片</p>
        <p class="info">（1）反对宪法所确定的基本原则的；</p>
        <p class="info">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p class="info">（3）损害国家荣誉和利益的；</p>
        <p class="info">4. 上传或发布的内容</p>
        <p class="info">用户上传的内容是指用户在网站上传或发布的视频或其它任何形式的内容包括文字、图片、音频等。除非浩伟智能技术人员收到相关通知，否则将用户视为其在本网站上传或发布的内容的版权拥有人。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。浩伟智能不承担任何法律及连带责任。对于经由本网站而传送的内容，浩伟智能不保证前述其合法性、正当性、准确性、完整性或品质。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header"
export default {
  components:{
    Header,
  },
  data(){
    return{
      theme:"black",
      detailBack:"http://www.hwznsoft.com/files/png/16B26BDA974A472686E4652D45D75C76.png",
    }
  },
  created(){
  },
  methods:{
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: auto;
  height: 100vh;

  .content{
    width: 100rem;
    min-height: 27.5rem;
    margin: 0 auto;
    color: #373737;

    .text{
      // margin: 1.25rem 0;
      margin: 2.5rem 0;
      // height: 40.625rem;

      .title{
        text-align: center;
        margin: 1.25rem 0;
        font-size: 2.1875rem;
        line-height: 2.5rem;
        font-weight: bold;
      }
      .info{
        margin-top: 1.0625rem;
        // color: #9A9A9A;
        font-size: 1.125rem;
        line-height: 1.5625rem;
        text-indent: 2.5rem;
      }
      .content{
        margin-top: 2rem;
        // height: 25rem;
        // max-height: 25rem;
        // min-height: 25rem;
        overflow:auto;
      }
      .recommend{
        margin-top: 3.75rem;

        .tip{
          color: #9A9A9A;
          font-size: .875rem;
          line-height: 1rem;
          cursor: pointer;
        }
        .tip:hover{
          color: #124FB0;
        }
      }
    }
  }

  .in{
    .text{
      animation: show 2s ease-out;
    }
    .title{
      animation: transIn 2s ease-out;
    }
  }
  .out{
    .text{
      animation: hidden 2s ease-out;
    }
    .title{
      animation: transOut 2s ease-out;
    }
  }
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes hidden {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>